module.exports = __webpack_public_path__ + "static/media/6.74a002ae.jpg";